import {loadCSS} from 'fg-loadcss';

declare var ajaxDataMain: {
    async_styles: string[];
    version: string;
    site_url: string;
};

window.loadCSS = loadCSS;

function loadStyles() {
    const assets = ajaxDataMain.site_url + '/assets/';
    const themePlugins = assets + 'theme-plugins/';
    let ver = `?ver=${ajaxDataMain?.version}`;

    try {
        loadCSS(assets + 'dist/secondary.css' + ver);
        loadCSS(assets + 'css/learndash/elumine-ld-dynamic.css');
        loadCSS(themePlugins + 'slick/slick.css');
        loadCSS(themePlugins + 'css/jquery-ui.min.css');
    } catch (e) {
        console.error("loadCSS Fehler", e);
        setTimeout(() => {
            console.info('loadCSS retry');
            loadStyles();
        }, 3000)
    }

    // loadCSS(themePlugins + 'css/fontawesome.min.css');

    // external

    if (typeof ajaxDataMain !== 'undefined' && ajaxDataMain.async_styles) {
        ajaxDataMain.async_styles.forEach(url => {
            try {
                loadCSS(url + ver);
            } catch (e) {
                console.error("loadCSS Fehler: ", url, e)
            }
        })
    }
}

loadStyles();
